import React from "react";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { CopyTradingPageDesktop, CopyTradingPageMobile } from "./CopyTradingView";

export const CopyTradingPage: React.FC = () => {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  return isDesktop ? <CopyTradingPageDesktop /> : <CopyTradingPageMobile />;
};
